import React from "react";

import { useTheme } from "styled-components";

import Icon from "../../../../../../../../../components/ui/icon/Icon";
import EditableInput from "../../inline-edit/EditableInput";
import EditableText from "../../inline-edit/EditableText";
import { CARDS_PROP } from "../../../../../../settings/features/cards/defaults";
import {
  CardContainer,
  CardHeading,
  CardLabel,
  CardParagraph,
  ImageBottom,
  ImageTop,
} from "./styles";

const ImageEight = ({ data, config, isEditable }) => {
  const theme = useTheme();

  return (
    <CardContainer>
      <div style={{ display: "flex", alignItems: "start", gap: "8px" }}>
        <Icon icon={data.icon} size="21px" />
        <CardHeading>
          {isEditable ? (
            <EditableText
              data={data}
              config={config}
              inputProp={CARDS_PROP.TITLE}
              customCalculatorStyles={{ minHeight: "1em" }}
            />
          ) : (
            data.title
          )}
        </CardHeading>
      </div>

      {config.layout.includes(CARDS_PROP.TEXT) && (
        <CardParagraph>
          {isEditable ? (
            <EditableText
              data={data}
              config={config}
              inputProp={CARDS_PROP.TEXT}
            />
          ) : (
            data.text
          )}
        </CardParagraph>
      )}

      <ImageTop image={data.image?.link} position={data.image.focalPoint} />
      <ImageBottom
        image={data.imageSecond?.link}
        position={data.imageSecond.focalPoint}
      />

      {config.layout.includes(CARDS_PROP.LABEL) && (
        <CardLabel
          background={data[CARDS_PROP.COLORS].accent[theme.name]}
          color={data[CARDS_PROP.COLORS].text[theme.name]}
        >
          {isEditable ? (
            <EditableInput
              inputProp={CARDS_PROP.LABEL}
              data={data}
              config={config}
              customStyles={{ textAlign: "center" }}
            />
          ) : (
            data.label
          )}
        </CardLabel>
      )}
    </CardContainer>
  );
};

export default ImageEight;
